/* AlignaFit Reviews — Dark PDP + Light Carousel */

function afStars(rating,size){
  size=size||18;var h='',full=Math.floor(rating),dec=rating-full,half=dec>=.3&&dec<=.7;
  for(var i=1;i<=5;i++){
    if(i<=full)h+='<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="#f5c518"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
    else if(half&&i===full+1)h+='<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="#f5c518"><path d="M12 17.77V2l-3.09 6.25L2 9.27l5 4.87-1.18 6.88z"/></svg>';
    else h+='<svg width="'+size+'" height="'+size+'" viewBox="0 0 24 24" fill="rgba(0,0,0,0.15)"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01z"/></svg>';
  }
  return h;
}

function afInitials(name){
  var parts=(name||'A').trim().split(/\s+/);
  if(parts.length>=2)return (parts[0].charAt(0)+parts[1].charAt(0)).toUpperCase();
  return parts[0].charAt(0).toUpperCase();
}

var AF_NAMES={
  'alignastrap-posture-corrector':'Posture Corrector',
  'alignaneck-alignment-pillow':'Neck Pillow',
  'lower-back-support-brace':'Lower Back Brace',
  'alignknee-brace':'Knee Brace',
  'alignaknee-orthopaedic-pillow':'Knee Pillow',
  'alignafit-foam-roller':'Foam Roller'
};

function afPhotoUrl(p, base){
  if(!p) return '';
  if(p.indexOf('//')!==-1 || p.indexOf('/')===0) return p;
  return (base||'')+p;
}

// Group visually-similar photos so we don't render two in a row.
var AF_PHOTO_GROUPS = {
  'rp-posture-1.jpg':'pc-wood','rp-posture-3.jpg':'pc-wood','rp-posture-4.jpg':'pc-wood',
  'rp-posture-2.jpg':'pc-fabric',
  'rp-neck-1.jpg':'neck-pillow','rp-neck-2.jpg':'neck-pillow','rp-neck-3.jpg':'neck-pillow','rp-neck-4.jpg':'neck-pillow',
  'rp-kneepillow-1.jpg':'kp-white','rp-kneepillow-2.jpg':'kp-white',
  'rp-lowerback-1.jpg':'lb-flat','rp-lowerback-2.jpg':'lb-flat',
  'rp-knee-v2-1.jpg':'kb-pair','rp-knee-v2-3.jpg':'kb-pair'
};
function afPhotoGroup(r){
  if(!r.photos||!r.photos.length)return null;
  var name=(r.photos[0].split('/').pop()||'').split('?')[0];
  return AF_PHOTO_GROUPS[name]||('p-'+name);
}
// After sorting, if two consecutive reviews share a photo group,
// pull a non-photo (or different-group) review up between them.
function afSeparateSimilar(list){
  for(var i=1;i<list.length;i++){
    var g1=afPhotoGroup(list[i-1]), g2=afPhotoGroup(list[i]);
    if(!g1||!g2||g1!==g2)continue;
    for(var j=i+1;j<list.length;j++){
      var g3=afPhotoGroup(list[j]);
      if(g3!==g1){
        var picked=list.splice(j,1)[0];
        list.splice(i,0,picked);
        break;
      }
    }
  }
  return list;
}

class AlignaFitReviews extends HTMLElement{
  connectedCallback(){
    this.page=0;
    this.perPage=parseInt(this.getAttribute('data-per-page'))||9;
    this.hideProduct=this.getAttribute('data-hide-product')==='true';
    this.assetsBase=this.getAttribute('data-assets-base')||'';
    this.sortBy='recent';this.data=null;this.filtered=[];
    var url=this.getAttribute('data-asset-url');
    if(!url)return;
    var self=this;
    fetch(url).then(function(r){return r.json()}).then(function(d){self.data=d;self.render()})
      .catch(function(){self.innerHTML='<p class="af-reviews__empty">Reviews could not be loaded.</p>'});
  }
  render(){
    this.applyFilters();
    var shown=this.filtered.slice(0,(this.page+1)*this.perPage);
    var hasMore=shown.length<this.filtered.length;
    var self=this;
    this.innerHTML=
      '<div class="af-reviews__controls">'+
        '<span class="af-reviews__showing">Showing '+shown.length+' of '+this.filtered.length+' reviews</span>'+
        '<div class="af-reviews__sort"><label>Sort by:</label>'+
          '<select id="af-sort">'+
            '<option value="recent"'+(this.sortBy==='recent'?' selected':'')+'>Most Recent</option>'+
            '<option value="highest"'+(this.sortBy==='highest'?' selected':'')+'>Highest Rated</option>'+
            '<option value="lowest"'+(this.sortBy==='lowest'?' selected':'')+'>Lowest Rated</option>'+
          '</select>'+
        '</div>'+
      '</div>'+
      '<div class="af-reviews__list">'+shown.map(function(r){return self.card(r)}).join('')+'</div>'+
      (hasMore?'<button class="af-reviews__load-more">Show More Reviews</button>':'');
    var sort=this.querySelector('#af-sort');
    if(sort)sort.onchange=function(e){self.sortBy=e.target.value;self.page=0;self.render()};
    var btn=this.querySelector('.af-reviews__load-more');
    if(btn)btn.onclick=function(){self.page++;self.render()};
  }
  applyFilters(){
    var r=this.data?this.data.reviews.slice():[];
    if(this.sortBy==='highest')r.sort(function(a,b){return b.rating-a.rating});
    else if(this.sortBy==='lowest')r.sort(function(a,b){return a.rating-b.rating});
    else{
      // default: photos first, then recent
      r.sort(function(a,b){
        var ap=(a.photos&&a.photos.length)?1:0, bp=(b.photos&&b.photos.length)?1:0;
        if(ap!==bp)return bp-ap;
        return new Date(b.date)-new Date(a.date);
      });
      afSeparateSimilar(r);
    }
    this.filtered=r;
  }
  card(r){
    var inits=afInitials(r.author);
    var pname=r.product_name||AF_NAMES[r.product_handle]||'';
    var product=(this.hideProduct||!pname)?'':('<span class="af-reviews__card-product"><a href="/products/'+r.product_handle+'">'+pname+'</a></span>');
    var metaBits=[];
    if(r.location)metaBits.push(r.location);
    if(r.verified)metaBits.push('Verified Buyer');
    var meta=metaBits.join(' \u00B7 ');
    var base=this.assetsBase;
    var photos='';
    if(r.photos&&r.photos.length){
      photos='<div class="af-reviews__card-photos">'+r.photos.map(function(p){
        var url=afPhotoUrl(p,base);
        return '<a href="'+url+'" target="_blank" rel="noopener" class="af-reviews__card-photo"><img src="'+url+'" alt="Customer photo" loading="lazy"></a>';
      }).join('')+'</div>';
    }
    return '<div class="af-reviews__card'+(photos?' af-reviews__card--has-photo':'')+'">'+
      '<div class="af-reviews__card-stars"><span class="af-stars">'+afStars(r.rating,18)+'</span></div>'+
      '<p class="af-reviews__card-body">&ldquo;'+r.body+'&rdquo;</p>'+
      photos+
      '<div class="af-reviews__card-footer">'+
        '<div class="af-reviews__avatar">'+inits+'</div>'+
        '<div>'+
          '<div class="af-reviews__author-name">'+r.author+'</div>'+
          (meta?'<div class="af-reviews__author-meta">'+meta+'</div>':'')+
        '</div>'+
        product+
      '</div>'+
    '</div>';
  }
}
customElements.define('alignafit-reviews',AlignaFitReviews);

class AlignaFitReviewCarousel extends HTMLElement{
  connectedCallback(){
    this.assetsBase=this.getAttribute('data-assets-base')||'';
    var url=this.getAttribute('data-asset-url');if(!url)return;
    var self=this;
    fetch(url).then(function(r){return r.json()}).then(function(d){self.render(afSeparateSimilar((d.reviews||[]).slice()))}).catch(function(){});
  }
  render(reviews){
    var base=this.assetsBase;
    this.innerHTML='<div class="af-carousel__track">'+reviews.map(function(r){
      var inits=afInitials(r.author);
      var pname=AF_NAMES[r.product_handle]||'';
      var photo='';
      if(r.photos&&r.photos.length){
        var url=afPhotoUrl(r.photos[0],base);
        photo='<div class="af-carousel__card-photo"><img src="'+url+'" alt="'+pname+' review photo" loading="lazy"></div>';
      }
      return '<div class="af-carousel__card'+(photo?' af-carousel__card--has-photo':'')+'">'+
        photo+
        '<div class="af-carousel__card-body-wrap">'+
          '<div class="af-carousel__card-stars"><span class="af-stars">'+afStars(r.rating,18)+'</span></div>'+
          '<p class="af-carousel__card-body">&ldquo;'+r.body+'&rdquo;</p>'+
          '<div class="af-carousel__card-footer">'+
            '<div class="af-carousel__avatar">'+inits+'</div>'+
            '<div class="af-carousel__card-author-block">'+
              '<span class="af-carousel__card-author">'+r.author+'</span>'+
              (r.location?'<span class="af-carousel__card-loc">'+r.location+'</span>':'')+
            '</div>'+
            (pname?'<a href="/products/'+r.product_handle+'" class="af-carousel__card-product">'+pname+'</a>':'')+
          '</div>'+
        '</div>'+
      '</div>';
    }).join('')+'</div>';
  }
}
customElements.define('alignafit-review-carousel',AlignaFitReviewCarousel);
